<svelte:options customElement="dst-at-navigation" />

<script lang="ts">
	import { baseUrls } from '@/config.ts';
	import { register as registerClosables } from '@/lib/closable.ts';
	import { initializeNavigation, onResizeNavigation } from '@/lib/navigation.ts';
	import { closableInformElement } from '@/stores/header_store.ts';
	import { onMount } from 'svelte';

	let root;
	const baseUrl = baseUrls.editorialweb_at;

	onMount(async () => {
		registerClosables(root, $closableInformElement);
		initializeNavigation(root);
	});
</script>

<svelte:window on:resize={onResizeNavigation} />

<div class="dst-navigation" bind:this={root}>
	<nav class="contextual" aria-label="Haupt-Navigation">
		<slot name="breadcrumb" />
		<a href="{baseUrl}/international">International</a>
		<a href="{baseUrl}/inland">Inland</a>
		<a href="{baseUrl}/wirtschaft">Wirtschaft</a>
		<a href="{baseUrl}/web">Web</a>
		<a href="{baseUrl}/sport">Sport</a>
		<a href="{baseUrl}/panorama">Panorama</a>
		<a href="{baseUrl}/kultur">Kultur</a>
		<a href="{baseUrl}/etat">Etat</a>
		<a href="{baseUrl}/wissenschaft">Wissenschaft</a>
		<a href="{baseUrl}/lifestyle">Lifestyle</a>
		<a href="{baseUrl}/diskurs">Diskurs</a>
		<a href="{baseUrl}/karriere">Karriere</a>
		<a href="{baseUrl}/immobilien">Immobilien</a>
		<a href="{baseUrl}/zukunft">Zukunft</a>
		<a href="{baseUrl}/gesundheit">Gesundheit</a>
		<a href="{baseUrl}/recht">Recht</a>
		<a href="{baseUrl}/lifestyle/familie">Familie</a>
		<a href="{baseUrl}/inland/bildung">Bildung</a>
		<a href="{baseUrl}/lifestyle/reisen">Reisen</a>
		<a href="{baseUrl}/diestandard">dieStandard</a>
		<a href="{baseUrl}/podcast">Podcast</a>
		<a href="{baseUrl}/video">Video</a>
		<a href="{baseUrl}/lifestyle/mobilitaet">Mobilität</a>
		<a href="{baseUrl}/meinwissensvorsprung">Mein Wissensvorsprung</a>
		<div class="app--header--navigation--overflowcontainer">
			<button
				type="button"
				class="app--header--navigation--overflowtoggle"
				data-closable-target="app--header--navigation--overflow"
				aria-haspopup="true"
				aria-expanded="false">mehr…</button
			>
			<dst-flyout data-closable="app--header--navigation--overflow" data-closable-active="false">
				<div class="app--header--navigation--overflow"></div>
			</dst-flyout>
		</div>
	</nav>
</div>

<style lang="scss" global>
	@use '../../scss/DstNavigation.scss';
</style>
